import React from 'react';
import TermItemSelectField from '../../../../Term/Components/TermItemSelectField';
import { BaseFieldProps } from '../../Inputs/BaseField/BaseField';

const P1MedicalFacilityField: React.FC<BaseFieldProps> = props => {
	return <TermItemSelectField {...props} termType='p1_medical_facility' />;
};

export default P1MedicalFacilityField;
